import NotificationBell from "@/components/NotificationBell";

export default function PageHeader({ overline, title, subtitle, children }) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div>
        {overline && <p className="overline mb-1">{overline}</p>}
        <h1 className="text-3xl font-extrabold tracking-tight text-navy" data-testid="page-title">
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {children}
        <NotificationBell />
      </div>
    </div>
  );
}
